import { render, staticRenderFns } from "./AmeldingFormWorkRelationLeaveAndLayoffs.vue?vue&type=template&id=4ffbae6d&scoped=true&functional=true&"
import script from "./AmeldingFormWorkRelationLeaveAndLayoffs.vue?vue&type=script&lang=ts&"
export * from "./AmeldingFormWorkRelationLeaveAndLayoffs.vue?vue&type=script&lang=ts&"
import style0 from "./AmeldingFormWorkRelationLeaveAndLayoffs.vue?vue&type=style&index=0&id=4ffbae6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "4ffbae6d",
  null
  
)

export default component.exports